import { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes';
import { authGuard } from './core/guards/auth.guards';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes)
    },

   {
      path: 'dashboard',
      canActivate: [authGuard],
      loadComponent: () => import('./features/dashboard/pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
    },
       {
        path: 'sales',
        canActivate: [authGuard],
        loadChildren: () => import('./features/sales/sales.routes').then(m => m.salesRoutes)
      },

       {
        path: 'offers',
        canActivate: [authGuard],
        loadChildren: () => import('./features/offers/offers.routes').then(m => m.offersRoutes)
      },
        {
        path: 'assessment',
        canActivate: [authGuard],
        loadChildren: () => import('./features/saller-assessment/seller-assessment.routes').then(m => m.AssessmentRoutes)
      },

         {
        path: 'applications',
        canActivate: [authGuard],
        loadChildren: () => import('./features/sales-applications/applications.routes').then(m => m.ApplicationsRoutes)
      },

       {
        path: 'message',
        loadChildren: () =>
          import('./features/newmessages/messages.routes').then(m => m.messageRoutes)
      },


      {
        path: 'faq',
        canActivate: [authGuard],
        loadChildren: () => import('./features/FAQ/faq.routes').then(m => m.faqRoutes)
      },

       {
        path: 'extend-booking',
        canActivate: [authGuard],
        loadChildren: () => import('./features/extendBooking/extend.routes').then(m => m.extendRoutes)
      },

     {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
    }

];
